module.exports = new __parcel__URL__("hair_gltfpack_cctc.bd17ae3a.glb").toString();